<template>
  <div style="margin-left: 40px; margin-right: 40px; margin-bottom: 40px">
    <div>
      <H2 style="padding-bottom: 20px">{{detail.title}}</H2>


    </div>
    <div style="padding-top:20px">
      <el-timeline v-if="this.detail !== null">
        <el-timeline-item v-for="content in this.detail.contents"
                          :timestamp="getTimeStampStr(content)"
                          :color="getColor(content.contentType)"
                          placement="top" size="large" style="font-size: 14px">
          <el-card style="margin-top: 5px">
            <div style="font-size: 16px; margin-top: 10px">{{ content.content }}</div>
            <div class="block" style="margin-top: 10px">
              <el-image v-for="image in content.images"
                        style="width: 100px; height: 100px; margin-right: 5px; border-radius: 4px;"
                        :src="image.url"
                        :preview-src-list="content.images.map(ans => ans.url)"
                        :fit="'cover'"></el-image>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "hot-ticket-detail",
  props: {id: String},
  data() {
    return {
      detail: null,
      detailObj: {
        id: '',
        title: '',
        contents:[{
          content: '',
          contentType: '',
          images: [{
            name:'',
            url:''
          }],
          updated: '',
        }],
      },
    }
  },

  watch: {
    id: {
      handler() {
        this.getDetail();
      }
    }
  },


  created() {
    this.getDetail();
  },


  methods: {
    getDetail() {
      if (this.id === undefined || this.isLoading) {
        return;
      }
      this.showCommonLoading();
      this.$axios.post('/ajax/doc/search/hot/info', {
        id: this.id
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.detail = res.data.data;
        }
      }).catch(e => {
        this.hideCommonLoading();
      });
    },
    getColor(type) {
      if (type === 2) {
        return '#0bbd87'
      } else {
        return '#F16222'
      }
    },
    getTimeStampStr(content) {
      let str = `${content.updated} `;
      if (content.contentType === 0) {
        str += '创建';
      } else if (content.contentType === 1) {
        str += '追问';
      } else if (content.contentType === 2) {
        str += '回答';
      }
      return str;
    },
  }
}
</script>

<style scoped>



</style>


// WEBPACK FOOTER //
// src/components/ticket/hot-ticket-detail.vue